import Vue from 'vue'
import { API_URL } from '../../api'
import CurrenciesFilter from '../../filters/CurrenciesFilter';
const state = {
    currencyCreate: {
        createdCurrency: null,
        creatingCurrency: false,
        createCurrencyStatus: null
    },
    currencyUpdate: {
        updatedCurrency: null,
        updatingCurrency: false,
        updateCurrencyStatus: null
    },
    currencyDelete: {
        deletingCurrency: false,
        deleteCurrencyStatus: null
    },
    currencySearch: {
        currenciesCount: null,
        currencies: [],
        searchingCurrencies: false,
        searchCurrencyStatus: null
    },
}
const mutations = {
    ['SET_CURRENCY_CREATE'](state, change) {
        state.currencyCreate = { ...state.currencyCreate, ...change };
    },
    ['SET_CURRENCY_UPDATE'](state, change) {
        state.currencyUpdate = { ...state.currencyUpdate, ...change };
    },
    ['SET_CURRENCY_DELETE'](state, change) {
        state.currencyDelete = { ...state.currencyDelete, ...change };
    },
    ['SET_CURRENCY_SEARCH'](state, change) {
        state.currencySearch = { ...state.currencySearch, ...change };
    }
}
const actions = {
    createCurrency: ({ commit }, payload) => {
        commit('SET_CURRENCY_CREATE', { createCurrencyStatus: null, createdCurrency: null, creatingCurrency: true })
        return Vue.http.post(API_URL + '/currencies/create', payload).then(response => {
            commit('SET_CURRENCY_CREATE', { createCurrencyStatus: 'success', createdCurrency: response.body.results.currency });
        }).catch(response => {
            commit('SET_CURRENCY_CREATE', { createCurrencyStatus: 'failed' });
        }).finally(() => {
            commit('SET_CURRENCY_CREATE', { creatingCurrency: false });
        });
    },
    updateCurrency: ({ commit }, payload) => {
        commit('SET_CURRENCY_UPDATE', { updateCurrencyStatus: null, updatedCurrency: null, updatingCurrency: true })
        return Vue.http.post(API_URL + '/currencies/update/' + payload.id, payload)
            .then(response => {
                commit('SET_CURRENCY_UPDATE', { updateCurrencyStatus: 'success', updatedCurrency: response.body.results.currency });
            })
            .catch(response => {
                commit('SET_CURRENCY_UPDATE', { updateCurrencyStatus: 'failed' });
            })
            .finally(() => {
                commit('SET_CURRENCY_UPDATE', { updatingCurrency: false });
            })
    },
    deleteCurrency: ({ commit }, id) => {
        commit('SET_CURRENCY_DELETE', { deleteCurrencyStatus: null, deletedCurrency: null, deletingCurrency: true })
        return Vue.http.delete(API_URL + '/currencies/delete/' + id).then(response => {
            commit('SET_CURRENCY_DELETE', { deleteCurrencyStatus: 'success' });
        }).catch(response => {
            commit('SET_CURRENCY_DELETE', { deleteCurrencyStatus: 'failed' });
        }).finally(() => {
            commit('SET_CURRENCY_DELETE', { deletingCurrency: false });
        })
    },
    searchCurrencies: ({ commit }, payload = { filter: CurrenciesFilter(), resultMode: 'default' }) => {
        commit('SET_CURRENCY_SEARCH', { searchCurrencyStatus: null, searchCurrency: null, searchingCurrencies: true })
        let filerJson = JSON.stringify(payload.filter);
        switch (payload.resultMode) {
            case 'count': payload.resultMode = 1; break;
            case 'paginated': payload.resultMode = 2; break;
            case 'paginatedPersist': payload.resultMode = 21; break;
            default: payload.resultMode = 0; break;
        }
        var params = '?query=' + encodeURIComponent(filerJson) + '&result_mode=' + payload.resultMode;
        return Vue.http.get(API_URL + '/currencies' + params).then(response => {
            commit('SET_CURRENCY_SEARCH', { searchCurrencyStatus: 'success', currencies: response.body.results.currencies });
        }).catch(response => {
            commit('SET_CURRENCY_SEARCH', { searchCurrencyStatus: 'failed' });
        }).finally(() => {
            commit('SET_CURRENCY_SEARCH', { searchingCurrencies: false });
        })
    },
}
export default {
    state, mutations, actions
} 



// WEBPACK FOOTER //
// ./resources/js/store/modules/currencyStore.js